import {useInjection} from "inversify-react";
import {useEffect, useState} from "react";
import ApiService from "../../services/apiService";
import {ProductPriceApi, ProductPriceCreateDto, ProductPriceDto, ProductPriceUpdateDto} from "../../api";
import ProductPricesList from "./productPriceList";
import ProductPriceModalFormAddContainer from "./productPriceModalFormAddContainer/productPriceModalFormAddContainer";
import {Button, Layout} from "antd";
import {Content} from "antd/lib/layout/layout";
import styles from "./productPriceListContainer.module.scss";
import {useNavigate, useParams} from "react-router-dom";

export default function ProductPricesListContainer() {

    const navigate = useNavigate();
    const apiService = useInjection(ApiService);
    const [productPrices, setProductPrices] = useState<ProductPriceDto[] | null>();
    const [isAddFormVisible, setAddFormVisible] = useState(false);
    const [productPriceModalFormContainerTitle, setProductPriceModalFormContainerTitle] = useState<string>();
    const [productPriceToEdit, setProductPriceToEdit] = useState<ProductPriceUpdateDto | null>(null);
    const [idProductPriceToEdit, setIdProductPriceToEdit] = useState<number | null>(null);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    let {productId} = useParams();

    const refreshProductPricesList = async () => {
        setIsLoading(true);

        try {
            const ProductPrices = await apiService.getApi(ProductPriceApi)
                .apiProductPriceProductPricesProductIdGet(+productId!);
            setProductPrices(ProductPrices.data);
        } catch (e: any) {
            console.log(e.response.data);
        }
        setIsLoading(false);
    }

    useEffect(() => {
        refreshProductPricesList();
    }, [])

    const onAddClicked = () => {
        setProductPriceModalFormContainerTitle("Dodaj nową cenę");
        setProductPriceToEdit(null);
        setIdProductPriceToEdit(null);
        setAddFormVisible(true);
    }

    const onEditClicked = async (id: number) => {
        setProductPriceModalFormContainerTitle(`Edytuj cenę: ${id}`);
        setIsLoading(true);

        const response = await apiService.getApi(ProductPriceApi).apiProductPriceIdGet(id);

        setProductPriceToEdit(response.data as ProductPriceUpdateDto);
        setIdProductPriceToEdit(id);
        setAddFormVisible(true);
        setIsLoading(false);
    }

    const onDeleteClicked = async (id: number) => {
        const response = await apiService.getApi(ProductPriceApi).apiProductPriceIdDelete(id)

        if (response.request.status !== 200) {
            console.log("Error occured while deleting data"); //add some warning?
        } else {
            refreshProductPricesList();
        }
    }

    const onSubmit = async (values: ProductPriceCreateDto | ProductPriceUpdateDto) => {
        try {
            if (productPriceToEdit === null) {
                values.productId = +productId!;
                await apiService.getApi(ProductPriceApi).apiProductPricePost(values);
            } else if (idProductPriceToEdit !== null) {
                values.productId = +productId!;
                await apiService.getApi(ProductPriceApi).apiProductPriceIdPut(idProductPriceToEdit, values)
            }
        } catch (e: any) {
            return e.response.data;
        }

        setAddFormVisible(false)
        await refreshProductPricesList();
    }

    return <Layout style={{backgroundColor: "white"}}>
        <Content>
            <Layout>
                <Content className={styles.content}>
                    <ProductPricesList
                        data={productPrices || null}
                        onAddClicked={onAddClicked}
                        onEditClicked={onEditClicked}
                        onDeleteClicked={onDeleteClicked}
                    />
                    <ProductPriceModalFormAddContainer
                        onFinish={() => setAddFormVisible(false)}
                        onSubmit={onSubmit}
                        addFormVisibility={isAddFormVisible}
                        title={productPriceModalFormContainerTitle || ""}
                        ProductPriceToEdit={productPriceToEdit}
                    />
                    <Button style={{marginTop: "1rem"}} onClick={() => navigate(-1)}>
                        Wróć
                    </Button>
                </Content>
            </Layout>
        </Content>
    </Layout>;
}
